import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { NavigationPanel } from 'components';
import './styles.scss';

const LayoutDefault = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return (<div className="splash" />);
  }

  return (
    <div className="layout-default">
      <article>
        <NavigationPanel />
      </article>
      <section>
        {children}
      </section>
    </div>
  );
};

export default LayoutDefault;
